// eslint-disable-next-line import/prefer-default-export
export const getElementStyle = (elementKey, elementStyles = []) => {
  const styles = elementStyles.find(
    elementStyle => elementStyle.element === elementKey,
  );
  return styles ? styles.style : {};
};
